import { useContext } from 'react';

import { UserContext } from '../../providers/user-provider';
import type { UserContextValue } from '../../providers/user-provider/types';

export const useAtlassianUserContext = (): NonNullable<UserContextValue> => {
	const context = useContext(UserContext);

	if (!context) {
		throw new Error('useAtlassianUserContext must be used within UserProvider');
	}

	return context;
};
